'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./signature-modal.scss');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = require('react-intl');

var _drawTab = require('./draw-tab');

var _drawTab2 = _interopRequireDefault(_drawTab);

var _savedTab = require('./saved-tab');

var _savedTab2 = _interopRequireDefault(_savedTab);

var _errorTab = require('./error-tab');

var _errorTab2 = _interopRequireDefault(_errorTab);

var _emailTab = require('./email-tab');

var _emailTab2 = _interopRequireDefault(_emailTab);

var _typeInTab = require('./type-in-tab');

var _typeInTab2 = _interopRequireDefault(_typeInTab);

var _uploadTab = require('./upload-tab');

var _uploadTab2 = _interopRequireDefault(_uploadTab);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _loader = require('signer/components/common/loader');

var _loader2 = _interopRequireDefault(_loader);

var _setInterval = require('common/utils/set-interval');

var _setInterval2 = _interopRequireDefault(_setInterval);

var _propTypes = require('./prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // 'Use Smartphone'


var PropTypes = _react2['default'].PropTypes;

/**
 * UI Signature Modal
 *
 * This component is a presentational version of the signature modal.  It
 * expects all state management to be handled by a parent component.
 *
 * NOTE: This component assumes that it has been wrapped within an Intl
 * Provider _and_ a component injected with the imperative intl API.
 *
 * @example
 *
 * import { IntlProvider, injectIntl } from 'react-intl';
 *
 * // Wraps the UI signature modal and handles all the state logic
 * class MyStatefulSignatureModal extends React.Component {
 *      render() {
 *          return <SignatureModal
 *              //...props
 *          />
 *      }
 *
 * }
 * const IntlSignatureModal = injectIntl(MyStatefulSignatureModal);
 *
 * <IntlProvider locale='en-US' messages={messages}>
 *      <IntlSignatureModal />
 * </IntlProvider>
 */

var UiSignatureModal = function (_React$Component) {
    _inherits(UiSignatureModal, _React$Component);

    function UiSignatureModal() {
        var _ref;

        _classCallCheck(this, UiSignatureModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = UiSignatureModal.__proto__ || Object.getPrototypeOf(UiSignatureModal)).call.apply(_ref, [this].concat(args)));

        _this.captureMenu = _this.captureMenu.bind(_this);
        _this.captureActiveTab = _this.captureActiveTab.bind(_this);
        _this.getTopOffset = _this.getTopOffset.bind(_this);
        _this.detectDeviceOrientation = _this.detectDeviceOrientation.bind(_this);
        _this.detectScreenSize = _this.detectScreenSize.bind(_this);
        _this.adjustDimensions = _this.adjustDimensions.bind(_this);
        _this.shouldShowTab = _this.shouldShowTab.bind(_this);
        _this.errorOnContinue = _this.errorOnContinue.bind(_this);
        _this.renderMenu = _this.renderMenu.bind(_this);
        _this.renderTabs = _this.renderTabs.bind(_this);
        _this.renderTab = _this.renderTab.bind(_this);

        _this.state = {
            deviceOrientation: _this.detectDeviceOrientation(),
            screenSize: _this.detectScreenSize()
        };
        return _this;
    }

    _createClass(UiSignatureModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.mounted = true;

            if (this.props.isMobile) {
                var adjTimer;

                var adjustOrientationAndSize = function adjustOrientationAndSize() {

                    if (!_this2.mounted) return clearInterval(adjTimer);

                    var orientation = _this2.detectDeviceOrientation();
                    var screenSize = _this2.detectScreenSize();

                    _this2.adjustDimensions();

                    _this2.setState({
                        'deviceOrientation': orientation,
                        'screenSize': screenSize
                    });
                };

                // Orientation and size detection
                // adjust size on a timer. Do NOT use listeners! This fixes strange iOS bugs (CC)
                adjTimer = (0, _setInterval2['default'])(adjustOrientationAndSize, 250);
                adjustOrientationAndSize();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.mounted = false;
        }

        //  ----  HELPERS  ------------------------------------

    }, {
        key: 'captureMenu',
        value: function captureMenu(node) {
            this.menuRef = node;
        }
    }, {
        key: 'captureActiveTab',
        value: function captureActiveTab(node) {
            this.activeTabRef = node;
        }

        /**
         * Returns the max of the following two numbers:
         *  - The bottom offset of the menu node
         *  - The bottom offset of the tab content node
         *
         * We use this calculation to display the `ActionBar` at the correct height
         * below the lower of the two nodes.  In some cases, the tab content may be shorter
         * than the menu, so in those cases we don't want the menu to overlap with
         * the action bar.  This only happes for mobile devices
         */

    }, {
        key: 'getTopOffset',
        value: function getTopOffset() {

            // Note, React may provide `undefined` for ref callbacks if the nodes
            // have been unmounted, so we need to check for their existence before
            // trying to call DOM methods.
            if (this.props.isMobile && this.menuRef && this.activeTabRef) {
                var menuBottom = this.menuRef.getBoundingClientRect().bottom;
                var activeTabBottom = this.activeTabRef.getBoundingClientRect().bottom;

                return Math.max(menuBottom, activeTabBottom);
            }
        }
    }, {
        key: 'detectDeviceOrientation',
        value: function detectDeviceOrientation() {
            if (this.props.isMobile && window.screen) {
                if (window.orientation !== void 0 && Math.abs(window.orientation) === 90 || window.screen && window.screen.width > window.screen.height) {
                    // NOTE: Only used for in-browser mobile simulators because they don't emulate orientation changes correctly
                    return _constants2['default'].ORIENTATION_LANDSCAPE;
                } else {
                    return _constants2['default'].ORIENTATION_PORTRAIT;
                }
            } else {
                return _constants2['default'].ORIENTATION_LANDSCAPE;
            }
        }
    }, {
        key: 'detectScreenSize',
        value: function detectScreenSize() {
            if (window.screen) {
                var w = window.screen.width;
                if (w <= 690) {
                    return _constants2['default'].SCREEN_SMALL;
                } else if (w > 690 && w <= 900) {
                    return _constants2['default'].SCREEN_MEDIUM;
                }
            }
            return _constants2['default'].SCREEN_LARGE;
        }
    }, {
        key: 'adjustDimensions',
        value: function adjustDimensions() {
            if (window.screen && this.props.isMobile && this.state.screenSize === _constants2['default'].SCREEN_SMALL) {

                // NOTE: The height is must be at least 270px to prevent the action bar from running into the menu.
                // Also, in such case, the keyboard is most likely up, so the user can dismiss it to see the rest of the modal.

                var root = $(_reactDom2['default'].findDOMNode(this));
                var h = Math.max(270, window.innerHeight);
                var w = window.innerWidth;
                var isEmbedded = this.props.isEmbedded;

                if (isEmbedded) {
                    // Set full width for embedded. Avoids mobile iframe issues.
                    root.css({
                        'width': '100vw',
                        'height': '100vh',
                        'min-height': '270px',
                        'top': 0,
                        'left': 0
                    });
                } else {
                    root.css({
                        'width': w + 'px',
                        'height': h + 'px',
                        'top': 0,
                        'left': 0
                    });
                }
            }
        }
    }, {
        key: 'shouldShowTab',
        value: function shouldShowTab(tabId) {
            var enabledTabs = this.props.enabledTabs;

            // Block Upload and Smartphone (email) on mobile

            if (this.props.isMobile && (tabId === _constants2['default'].TAB_UPLOAD || tabId === _constants2['default'].TAB_EMAIL)) {
                return false;
            }

            // Never show error tab in menu
            if (tabId === _constants2['default'].TAB_ERROR) return false;

            // Show if true or not specified
            return this.props.selectedTab === tabId || enabledTabs.includes(tabId);
        }

        //  ----  BEHAVIOR  -----------------------------------

    }, {
        key: 'errorOnContinue',
        value: function errorOnContinue() {
            this.props.onTabSelect(_constants2['default'].TAB_SAVED);
        }

        //  ----  RENDERING  ----------------------------------

    }, {
        key: 'renderMenu',
        value: function renderMenu() {

            var menuItems = [];
            var classes;

            for (var k in _constants2['default'].TABS) {

                var tabId = _constants2['default'].TABS[k];
                if (!this.shouldShowTab(tabId)) {
                    continue;
                }

                if (this.props.isEmbedded && tabId === _constants2['default'].TAB_SAVED) {
                    // use placeholder and don't show saved menu if embedded signing -- DEV-1718
                    menuItems.push(_react2['default'].createElement('div', { key: 'sign-modal-menuitem-' + tabId }));
                } else {
                    classes = {
                        'm-sign-modal--menu--item': true,
                        'is-compact': this.props.isMobile,
                        'is-selected': this.props.selectedTab === tabId,
                        'whitelabel-signature-modal-tab': true
                    };

                    classes[tabId] = true;

                    menuItems.push(_react2['default'].createElement(
                        'div',
                        { key: 'sign-modal-menuitem-' + tabId, className: (0, _classnames2['default'])(classes), onClick: this.props.onTabSelect.bind(null, tabId) },
                        _react2['default'].createElement('span', { className: 'm-sign-modal--menu--item--icon' }),
                        _react2['default'].createElement(
                            'span',
                            { className: 'm-sign-modal--menu--item--label' },
                            _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.menu.labelText',
                                values: { tabId: tabId + (tabId == _constants2['default'].TAB_SAVED ? this.props.type : '') } })
                        )
                    ));
                }
            }

            return _react2['default'].createElement(
                'div',
                { className: 'm-sign-modal--menu', ref: this.captureMenu },
                menuItems
            );
        }
    }, {
        key: 'renderTabs',
        value: function renderTabs() {
            var _this3 = this;

            var tabs = _constants2['default'].TABS.filter(function (id) {
                return _this3.props.selectedTab === id;
            }).map(function (id) {
                return _this3.renderTab(id);
            });
            return _react2['default'].createElement(
                'div',
                { className: 'm-sign-modal--tabs' },
                tabs
            );
        }
    }, {
        key: 'renderTab',
        value: function renderTab(tabId) {
            var _props = this.props,
                buttonText = _props.buttonText,
                canInsertEverywhere = _props.canInsertEverywhere,
                emailedSignature = _props.emailedSignature,
                emailGuid = _props.emailGuid,
                emailUploadAddress = _props.emailUploadAddress,
                error = _props.error,
                getSignatureUrl = _props.getSignatureUrl,
                initialTypeInValue = _props.initialTypeInValue,
                intl = _props.intl,
                isCheckingEmailedSignatureStatus = _props.isCheckingEmailedSignatureStatus,
                isMobile = _props.isMobile,
                isUploadingSignature = _props.isUploadingSignature,
                onCheckEmailedSignatureStatus = _props.onCheckEmailedSignatureStatus,
                onCheckNetworkHealth = _props.onCheckNetworkHealth,
                onClose = _props.onClose,
                onError = _props.onError,
                onInsert = _props.onInsert,
                onRotateSignature = _props.onRotateSignature,
                onSavedSignatureRemove = _props.onSavedSignatureRemove,
                onSavedSignatureSelect = _props.onSavedSignatureSelect,
                onSignatureData = _props.onSignatureData,
                onUploadSignature = _props.onUploadSignature,
                savedSignatures = _props.savedSignatures,
                selectedSavedSignature = _props.selectedSavedSignature,
                selectedTab = _props.selectedTab,
                type = _props.type,
                uploadedSignature = _props.uploadedSignature;
            var _state = this.state,
                deviceOrientation = _state.deviceOrientation,
                screenSize = _state.screenSize;


            var topOffset = this.getTopOffset();
            var displayOrientation = isMobile ? _constants2['default'].ORIENTATION_PORTRAIT : _constants2['default'].ORIENTATION_LANDSCAPE;

            var tab;
            var key = 'tab-' + tabId;
            var isSelected = selectedTab === tabId;

            var commonActionBarProps = {
                buttonText: buttonText,
                canInsertEverywhere: canInsertEverywhere,
                intl: intl,
                isMobile: isMobile,
                onClose: onClose,
                topOffset: topOffset,
                type: type
            };

            var commonProps = {
                actionBarProps: commonActionBarProps,
                buttonText: buttonText,
                canInsertEverywhere: canInsertEverywhere,

                // Provided to the Tab components so that they can report their
                // content to this component.  The tabs should apply this as a ref
                // callback on the div that wraps the content, e.g.
                // <div ref={this.props.captureTabContentRef}>
                captureTabContentRef: this.captureActiveTab,
                deviceOrientation: deviceOrientation,
                emailGuid: emailGuid,
                emailUploadAddress: emailUploadAddress,
                isMobile: isMobile,
                intl: intl,
                isSelected: isSelected,
                onClose: onClose,
                onError: onError,
                screenSize: screenSize,
                topOffset: topOffset,
                type: type
            };

            switch (tabId) {

                case _constants2['default'].TAB_SAVED:
                    tab = _react2['default'].createElement(_savedTab2['default'], _extends({}, commonProps, {
                        key: key,
                        getSignatureUrl: getSignatureUrl,
                        onInsert: onInsert,
                        onRemove: onSavedSignatureRemove,
                        onSelect: onSavedSignatureSelect,
                        selectedSignature: selectedSavedSignature,
                        signatures: savedSignatures
                    }));
                    break;

                case _constants2['default'].TAB_DRAW:
                    tab = _react2['default'].createElement(_drawTab2['default'], _extends({}, commonProps, {
                        displayOrientation: displayOrientation,
                        key: key,
                        onSignatureData: onSignatureData
                    }));
                    break;

                case _constants2['default'].TAB_TYPE:
                    tab = _react2['default'].createElement(_typeInTab2['default'], _extends({}, commonProps, {
                        key: key,
                        initialValue: initialTypeInValue,
                        onCheckNetworkHealth: onCheckNetworkHealth,
                        onSignatureData: onSignatureData
                    }));
                    break;

                case _constants2['default'].TAB_UPLOAD:
                    tab = _react2['default'].createElement(_uploadTab2['default'], _extends({}, commonProps, {
                        getSignatureUrl: getSignatureUrl,
                        key: key,
                        isUploading: isUploadingSignature,
                        onRotateSignature: onRotateSignature,
                        onSignatureData: onSignatureData,
                        onUpload: onUploadSignature,
                        signature: uploadedSignature
                    }));
                    break;

                case _constants2['default'].TAB_EMAIL:
                    tab = _react2['default'].createElement(_emailTab2['default'], _extends({}, commonProps, {
                        emailGuid: emailGuid,
                        key: key,
                        getSignatureUrl: getSignatureUrl,
                        isCheckingStatus: isCheckingEmailedSignatureStatus,
                        onCheckStatus: onCheckEmailedSignatureStatus,
                        onRotateSignature: onRotateSignature,
                        onSignatureData: onSignatureData,
                        signature: emailedSignature,
                        uploadAddress: emailUploadAddress
                    }));
                    break;

                case _constants2['default'].TAB_ERROR:
                    tab = _react2['default'].createElement(_errorTab2['default'], _extends({
                        key: key
                    }, commonProps, {
                        error: error,
                        onContinue: this.errorOnContinue
                    }));
                    break;

                default:
                    throw new Error('Invalid tab id: ' + tabId);

            }

            return tab;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                isLoading = _props2.loading,
                loaderContent = _props2.loaderContent,
                onClose = _props2.onClose;

            var classes = {
                'm-sign-modal': true,
                'is-mobile': this.props.isMobile,
                'is-desktop': !this.props.isMobile,
                'can-insert-everywhere': this.props.canInsertEverywhere
            };
            classes['screen-' + this.state.screenSize] = true;
            classes['orientation-' + this.state.deviceOrientation] = true;

            var loader = _react2['default'].createElement(
                'div',
                { className: 'm-sign-modal--loader' },
                _react2['default'].createElement(_loader2['default'], { className: 'm-sign-modal--loader--image whitelabel-dot-loader' }),
                _react2['default'].createElement(
                    'span',
                    { className: 'm-sign-modal--loader--text' },
                    loaderContent
                )
            );

            var closeBox = _react2['default'].createElement(
                'div',
                { className: 'm-sign-modal--close-box', onClick: onClose },
                _react2['default'].createElement('img', { src: require('./x@2x.png') })
            );

            // Render the signature modal
            return _react2['default'].createElement(
                'div',
                { className: (0, _classnames2['default'])(classes) },
                isLoading ? loader : null,
                isLoading ? null : this.renderMenu(),
                isLoading || this.props.isMobile ? null : closeBox,
                isLoading ? null : this.renderTabs()
            );
        }
    }]);

    return UiSignatureModal;
}(_react2['default'].Component);

UiSignatureModal.propTypes = {

    /**
        * Text to be displayed on the CTA (only when canInsertEverywhere=false)
        */
    buttonText: _react2['default'].PropTypes.string,

    /**
        * If true, there will be a button displayed to insert everywhere
        */
    canInsertEverywhere: PropTypes.bool,

    /**
        * The emailed signature that's been sent in by the user.
        */
    emailedSignature: _propTypes.SignatureType,

    /**
        * For signature upload
        */
    emailGuid: PropTypes.string,
    emailUploadAddress: PropTypes.string,

    enabledTabs: PropTypes.arrayOf(_propTypes.Tab),

    /**
        * Provided to the error tab if present.
        */
    error: PropTypes.shape({
        message: PropTypes.string
    }),

    getSignatureUrl: _propTypes.GetSignatureUrl,

    /**
     * Provided to the TypeInTab
     */
    initialTypeInValue: PropTypes.string.isRequired,

    /**
     * Intl object provided by react-intl
     */
    intl: PropTypes.object.isRequired,

    /**
        * If true, it will signal to the email tab that we're awaiting an
        * emailed signature.
        */
    isCheckingEmailedSignatureStatus: PropTypes.bool,
    isEmbedded: PropTypes.bool,
    isMobile: PropTypes.bool,

    /**
        * If true, it will signal to the upload tab that we're awaiting a
        * signature upload.
        */
    isUploadingSignature: PropTypes.bool,

    /**
        * If provided and the `loading` prop is true, it will be used as the
        * content for the loading section.  Can be used to pass custom copy,
        * e.g. "Creating your signature..."
        */
    loaderContent: PropTypes.element,
    loading: PropTypes.bool,

    /**
        * This will kick off the API poll to check for emailed signatures.
        */
    onCheckEmailedSignatureStatus: PropTypes.func,

    /**
        * Called to close the modal
        */
    onClose: PropTypes.func,

    /**
        * Called with the finalized created signature from one of the tabs.
        */
    onInsert: PropTypes.func,

    /**
        * This prop should be used with caution. It's expected to take a
        * callback and somehow check if we're currently online.  If so, it
        * calls the callback.  It's used with the Webfont Loader in the type in
        * tab because we load the webfonts because they load using their own
        * network layer logic.
        */
    onCheckNetworkHealth: PropTypes.func,

    onRotateSignature: PropTypes.func,

    /**
        * Called with the siganture data from one of the tabs.  Each type will
        * have a "create_type_code" indicating which tab the data came from.
        * Use this to create or edit a signature.
        */
    onSignatureData: PropTypes.func.isRequired,

    /**
        * Called to remove a saved signature from the Saved Tab
        */
    onSavedSignatureRemove: PropTypes.func.isRequired,

    /**
        * Called to select a saved signature from the saved tab carousel
        */
    onSavedSignatureSelect: PropTypes.func.isRequired,
    onTabSelect: PropTypes.func.isRequired,
    onUploadSignature: PropTypes.func,

    /**
        * Provided to the saved tab to display as a carousel or list
        */
    savedSignatures: PropTypes.arrayOf(_propTypes.SignatureType).isRequired,

    /**
        * The signature in the saved tab that's currently selected
        */
    selectedSavedSignature: _propTypes.SignatureType,

    /**
        * The currently selected tab
        */
    selectedTab: PropTypes.oneOf(_constants2['default'].TABS),
    type: _propTypes.Type,
    uploadedSignature: _propTypes.SignatureType
};

UiSignatureModal.defaultProps = {
    enabledTabs: _constants2['default'].TABS.filter(function (tab) {
        return tab !== _constants2['default'].TAB_ERROR;
    }),
    type: _constants2['default'].TYPE_SIGNATURE,
    isMobile: true,
    canInsertEverywhere: true,
    isEmbedded: false
};

exports['default'] = UiSignatureModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/signature-modal/signature-modal.jsx
 ** module id = 783
 ** module chunks = 0 1
 **/